// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c7e23ebf","warningMessage":"bc707230","editButton":"f0c06297"};